<template>
<div class="card">
    <loading :active.sync="isLoading" 
        :can-cancel="false" 
        :is-full-page="true">
    </loading>

    <div class="card-header">
        <p class="card-header-title">Add a Category</p>
    </div>
    <div class="card-content">
        <b-message type="is-info">
            Categories can be assigned to behaviors, and it is used to calculate the average points of the behavior according to the value you set below. You can download the average points by going to 'Overall Behavior' and select either 'Monthly' or 'Yearly'.
        </b-message>

        <div class="columns">
            <div class="column is-6">
                <input class="input is-success" type="text" placeholder="Category Name (E.g.: O Level, Time Management, Recycle Program etc)" v-model="name">
            </div>
            <div class="column is-6">
                <input class="input" type="number" placeholder="Average Marks (E.g.: 5 for gpa or 100 for percentage)" v-model="points">
            </div>
        </div>
        <div class="columns">
            <div class="column is-1">
                Colour:
            </div>
            <div class="column is-5">
                <slider-picker v-model="colour" />
            </div>
            <div class="column is-2">                
                <b-select id="status" name="status" v-model="status">
                    <option selected value="1">Active</option>
                    <option value="0">Inactive</option>
                </b-select>
            </div>
            <div class="column">
                <button class='button is-primary  is-fullwidth' v-on:click="sendForm()" >Create</button>
            </div>
        </div>
    </div>
</div>
</template>
<script>
import axios from 'axios'
import { ToastProgrammatic as Toast } from 'buefy'
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import { Slider } from 'vue-color'

export default {
    name: "ManageKelasAdd",
    components:{
        Loading,
        'slider-picker': Slider,
    },
    data() {
        return {
            schoolPlan: 1,
            isLoading: false,
            name: '',
            points: '',
            colour: '#0C4BF7',
            status: 1
        };
    },
    created() {
        this.schoolPlan = localStorage.getItem('plan')

        if (this.schoolPlan == 1){
            
        }else{
    
        }
    },
    methods: {
        sendForm() {
            let self = this;

            var name = self.name;
            var points = self.points;
            var colour = self.colour;
            var status = self.status;
            var selectedColour = "";
            if (!colour.hex){
                selectedColour = "#0C4BF7"
            }else{
                selectedColour = colour.hex
            }

            if ((!name) || (name.length < 1)){
                Toast.open({
                    message: "Please enter the category name",
                    type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                    duration: 3000
                })
                return false;
            }else{
                name = name.trim()
            }
            if (!points){
                Toast.open({
                    message: "Please enter the value for the average marks",
                    type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                    duration: 3000
                })
                return false;
            }else{
                points = parseFloat(points)
            }
            self.isLoading = true;

            axios.defaults.responseType = 'json'
            axios.post(process.env.NEW_ENDPOINT + '/behaviors/tagAdd/', {
                token: localStorage.getItem('jwtTokenV2'),
                email: localStorage.getItem('email'),
                name: name,
                points: points,
                colour: selectedColour,
                status: status
            })
            .then(response => {
                self.isLoading = false;
                if (response.data.success == false) {
                    Toast.open({
                        message: response.data.msg,
                        type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        duration: 5000
                    })
                } else {
                    Toast.open({
                        color: 'is-dark', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        message: response.data.msg,
                        type: 'is-success',
                        duration: 3000
                    })
                }

                self.name = ""
                self.points = ""
                this.$parent.getTags()
            })
            .catch(e => {
                self.isLoading = false;
                console.log(e.response)
                if (e.response.status === 401) {                            
                    Toast.open({
                        message: "Unauthorized access. Please re-login.",
                        type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        duration: 5000
                    })
                } else {
                    Toast.open({
                        message: 'Error: ' + e.response.data.msg,
                        type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        duration: 5000
                    })
                }
            })
        },
    },
};
</script>
<style scoped>
.vertical-center{
    display: flex;
    align-items: center;
}
</style>


// WEBPACK FOOTER //
// src/components/Manage/Behaviors/AddTag.vue